import { Typography, Box } from '@mui/material'
import React from 'react'

const FooterDetails = () => {
    return (
        <Box sx={{ width: "100%",display:"flex",justifyContent:"space-around",color:"white" }}>
            <Box>
                <Typography>About</Typography>
                <Box>
                    <Typography>Contact us</Typography>
                    <Typography>About us</Typography>
                    <Typography>Careers</Typography>
                    <Typography>Information</Typography>
                </Box>
            </Box>
            <Box>
                <Typography>About</Typography>
                <Box>
                    <Typography>Contact us</Typography>
                    <Typography>About us</Typography>
                    <Typography>Careers</Typography>
                    <Typography>Information</Typography>
                </Box>
            </Box>
            <Box>
                <Typography>About</Typography>
                <Box>
                    <Typography>Contact us</Typography>
                    <Typography>About us</Typography>
                    <Typography>Careers</Typography>
                    <Typography>Information</Typography>
                </Box>
            </Box>
            <Box>
                <Typography>About</Typography>
                <Box>
                    <Typography>Contact us</Typography>
                    <Typography>About us</Typography>
                    <Typography>Careers</Typography>
                    <Typography>Information</Typography>
                </Box>
            </Box>
            <Box>
                <Typography>About</Typography>
                <Box>
                    <Typography>Contact us</Typography>
                    <Typography>About us</Typography>
                    <Typography>Careers</Typography>
                    <Typography>Information</Typography>
                </Box>
            </Box>
        </Box>
    )
}


export default FooterDetails